
<ngx-spinner bdColor = "rgba(51, 51, 51, 0.8)" size="large" color="#ffa501" [fullScreen]="false" type="ball-clip-rotate-multiple"
[fullScreen]="false">
<p class="loading">Loading ...</p>
</ngx-spinner>
      <router-outlet></router-outlet> 
